import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-6 mb-4" }
const _hoisted_3 = { class: "card shadow-sm border-start border-primary border-5" }
const _hoisted_4 = { class: "card-body d-flex align-items-center" }
const _hoisted_5 = { class: "mb-0" }
const _hoisted_6 = { class: "col-md-6 mb-4" }
const _hoisted_7 = { class: "card shadow-sm border-start border-success border-5" }
const _hoisted_8 = { class: "card-body d-flex align-items-center" }
const _hoisted_9 = { class: "mb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "me-3" }, [
            _createElementVNode("i", { class: "fas fa-users fa-2x text-primary" })
          ], -1)),
          _createElementVNode("div", null, [
            _cache[0] || (_cache[0] = _createElementVNode("h6", { class: "text-muted mb-1" }, "Utilisateurs", -1)),
            _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.stats.utilisateurs), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "me-3" }, [
            _createElementVNode("i", { class: "fas fa-briefcase fa-2x text-success" })
          ], -1)),
          _createElementVNode("div", null, [
            _cache[2] || (_cache[2] = _createElementVNode("h6", { class: "text-muted mb-1" }, "Métiers", -1)),
            _createElementVNode("h4", _hoisted_9, _toDisplayString(_ctx.stats.metiers), 1)
          ])
        ])
      ])
    ])
  ]))
}